module.exports = __webpack_public_path__ + "static/media/main2_en_768-min.46ecc0a8.png";